// extracted by mini-css-extract-plugin
module.exports = {"list":"style-module--list--3A3SI","item":"style-module--item--2ZU8p","iconContainer":"style-module--iconContainer--QP1e8","icon":"style-module--icon--laFOn"};